<script lang="ts" setup>

import { onBeforeUnmount, ref, watch } from 'vue'

const props = withDefaults(
  defineProps<{
    open?: boolean
    noPadding?: boolean
    small?: boolean
  }>(), {
    open: false,
    noPadding: false,
    small: false
  }
)
defineEmits(['close-modal'])

watch(() => props.open, (visible) => {
  if (visible) {
    document.body.classList.add('modal-open')
  } else {
    document.body.classList.remove('modal-open')
  }
})

onBeforeUnmount(() => {
  document.body.classList.remove('modal-open')
})

</script>

<template>
  <teleport to="body">
    <transition name="sancare-modal">
      <div
        v-if="open"
        class="sancare-modal-mask row g-0 justify-content-center align-items-start"
        @click.stop="$emit('close-modal')"
      >
        <div
          :class="{
            'col-12 col-md-9 col-lg-7 col-xl-6': !small,
            'col-9 col-md-5 col-lg-4 col-xl-3': small,
          }"
          class="sancare-modal-overlay"
          @click.stop
        >
          <div class="sancare-modal-header">
            <slot name="header" />
          </div>
          <div
            :class="{ 'no-padding': noPadding }"
            class="sancare-modal-body"
          >
            <slot />
          </div>
          <div class="sancare-modal-footer">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>
